import Vue from "vue";
import Router from "vue-router";
const Layout = () => import("@/page/layout/index");
const Home = () => import("@/page/home/index");
const Login = () => import("@/page/login/index");
const Register = () => import("@/page/register/index");
const Forget = () => import("@/page/forget/index");

// const RequestStatistics = () =>
//   import("@/page/productManage/requestStatistics");

const RequestStatistics = () =>
  import("@/page/productManage/requestStatistics/statistics.vue");
const RequestStatisticsDetail = () =>
  import("@/page/productManage/requestStatistics/statisticsDetail.vue");
const RequestRecord = () => import("@/page/productManage/requestRecord");
const DataQuery = () => import("@/page/productManage/dataQuery");
const BatchQuery = () => import("@/page/productManage/batchQuery");
const MyProduct = () => import("@/page/productManage/myProduct");
const OpenProduct = () => import("@/page/productManage/openProduct");
const productCall = () => import("@/page/productManage/productCall");
const ProductUsage = () => import("@/page/productManage/productUsage");
const ProductRenew = () => import("@/page/productManage/productRenew");
const ApiDoc = () => import("@/page/productManage/apiDoc");

const ConsumeStatistics = () =>
  import("@/page/financeManage/consumeStatistics");
const RechargeManage = () => import("@/page/financeManage/rechargeManage");
const RechargeRecord = () => import("@/page/financeManage/rechargeRecord");
const RechargeResult = () => import("@/page/financeManage/rechargeResult");
const OpenMember = () => import("@/page/financeManage/openMember");
const OpenVip = () => import("@/page/financeManage/openVip");
const PaymentResult = () => import("@/page/financeManage/paymentResult");
const MyOrder = () => import("@/page/financeManage/myOrder");
const WechatRecharge = () => import("@/page/financeManage/wechatRecharge");
const CreateOrder = () => import("@/page/financeManage/createOrder");
const CreateMessageOrder = () =>
  import("@/page/financeManage/createMessageOrder");

const PayOrder = () => import("@/page/financeManage/payOrder");
const OrderComment = () => import("@/page/financeManage/orderComment");
const OrderDetail = () => import("@/page/financeManage/orderDetail");
const InvoiceList = () => import("@/page/financeManage/invoice/list");
const InvoiceDetail = () => import("@/page/financeManage/invoice/detail");
const InvoiceTake = () => import("@/page/financeManage/invoice/take");
const InvoiceInfo = () => import("@/page/financeManage/invoice/info");
const CouponIndex = () => import("@/page/financeManage/coupon");
const CommissionIndex = () => import("@/page/financeManage/commission");
const CommissionDetailIndex = () =>
  import("@/page/financeManage/commission/detail");

const AccountManage = () => import("@/page/userManage/accountManage");
const SubAccountManage = () => import("@/page/userManage/subAccountManage");
const Certification = () => import("@/page/userManage/certification/index");
const Personal = () => import("@/page/userManage/certification/personal");
const Company = () => import("@/page/userManage/certification/company");
const Authenticated = () =>
  import("@/page/userManage/certification/authenticated");
const CertificationRecord = () =>
  import("@/page/userManage/certification/record");
const SuAccountDetails = () => import("@/page/userManage/suAccountDetails");

const SecurityManage = () => import("@/page/securityManage/security");
const SecurityJournal = () => import("@/page/securityManage/journal");
const SecurityWhiteList = () => import("@/page/securityManage/whiteList");
const BalanceWarning = () => import("@/page/securityManage/balanceWarning");

const MessageIndex = () => import("@/page/messageManage/message");
const MessageaAutograph = () => import("@/page/messageManage/autograph");
const MessageTemplate = () => import("@/page/messageManage/template");
const MessageRecord = () => import("@/page/messageManage/record");
const MessageRecordDetail = () =>
  import("@/page/messageManage/record/numbersDetail.vue");
const MessageSendMessage = () => import("@/page/messageManage/sendMessage");
const SSO = () => import("@/page/common/sso");
// 短链接管理
const ShortUrl = () => import("@/page/shortLinkManage/shortLink/list.vue");
const shortData = () =>
  import("@/page/shortLinkManage/shortLink/echartDetail.vue");
const shortDataArea = () =>
  import("@/page/shortLinkManage/shortLink/areaDetail.vue");

const createOreditShortUrl = () =>
  import("@/page/shortLinkManage/shortLink/createShortLink.vue");
const ShortUrlDoamin = () => import("@/page/shortLinkManage/domain/list.vue");

Vue.use(Router);

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: "/",
      component: Layout,
      redirect: "/home",
      children: [
        {
          path: "home",
          component: Home,
          meta: {
            title: "我的数聚",
            requireAuth: true
          }
        }
      ]
    },
    {
      path: "/product",
      component: Layout,
      children: [
        {
          path: "requestStatistics",
          component: RequestStatistics,
          meta: {
            title: "调用统计",
            requireAuth: true
          }
        },
        {
          path: "requestStatisticsDetail",
          component: RequestStatisticsDetail,
          meta: {
            title: "调用统计详情",
            requireAuth: true
          }
        },
        {
          path: "requestRecord",
          component: RequestRecord,
          meta: {
            title: "调用记录",
            requireAuth: true
          }
        },
        {
          path: "dataQuery",
          component: DataQuery,
          meta: {
            title: "在线调用",
            requireAuth: true
          }
        },
        {
          path: "batchQuery",
          component: BatchQuery,
          meta: {
            title: "批量调用",
            requireAuth: true
          }
        },
        {
          path: "myProduct",
          component: MyProduct,
          meta: {
            title: "我的产品",
            requireAuth: true
          }
        },
        {
          path: "openProduct",
          component: OpenProduct,
          meta: {
            title: "开通新产品",
            requireAuth: true
          }
        },
        {
          path: "apiDoc",
          component: ApiDoc,
          meta: {
            title: "API文档",
            requireAuth: true
          }
        },
        {
          path: "productRenew",
          component: ProductRenew,
          meta: {
            title: "产品购买",
            requireAuth: true
          }
        },
        {
          path: "productCall",
          component: productCall,
          meta: {
            title: "调用记录",
            requireAuth: true
          }
        },
        {
          path: "productUsage",
          component: ProductUsage,
          meta: {
            title: "调用统计",
            requireAuth: true
          }
        }
      ]
    },
    {
      path: "/finance",
      component: Layout,
      children: [
        {
          path: "consumeStatistics",
          component: ConsumeStatistics,
          meta: {
            title: "月账单",
            requireAuth: true
          }
        },
        {
          path: "rechargeManage",
          component: RechargeManage,
          meta: {
            title: "充值",
            requireAuth: true
          }
        },
        {
          path: "myOrder",
          component: MyOrder,
          meta: {
            title: "我的订单",
            requireAuth: true
          }
        },
        {
          path: "orderComment",
          component: OrderComment,
          meta: {
            title: "订单评价",
            requireAuth: true
          }
        },
        {
          path: "orderDetail",
          component: OrderDetail,
          meta: {
            title: "我的订单",
            requireAuth: true
          }
        },
        {
          path: "suAccountDetails",
          component: SuAccountDetails,
          meta: {
            title: "子账号",
            requireAuth: true
          }
        },
        {
          path: "invoice/list",
          component: InvoiceList,
          meta: {
            title: "发票管理",
            requireAuth: true
          }
        },
        {
          path: "invoice/detail",
          component: InvoiceDetail,
          meta: {
            title: "发票管理",
            requireAuth: true
          }
        },
        {
          path: "invoice/take",
          component: InvoiceTake,
          meta: {
            title: "索取发票",
            requireAuth: true
          }
        },
        {
          path: "invoice/info",
          component: InvoiceInfo,
          meta: {
            title: "发票信息管理",
            requireAuth: true
          }
        },
        {
          path: "coupon/index",
          component: CouponIndex,
          meta: {
            title: "优惠券",
            requireAuth: true
          }
        },
        {
          path: "commission/index",
          component: CommissionIndex,
          meta: {
            title: "佣金记录",
            requireAuth: true
          }
        },
        {
          path: "commission/detail",
          component: CommissionDetailIndex,
          meta: {
            title: "佣金记录详情",
            requireAuth: true
          }
        }
      ]
    },
    {
      path: "/finance",
      component: Layout,
      children: [
        {
          path: "consumeStatistics",
          component: ConsumeStatistics,
          meta: {
            title: "月账单",
            requireAuth: true
          }
        },
        {
          path: "rechargeManage",
          component: RechargeManage,
          meta: {
            title: "充值",
            requireAuth: true
          }
        },
        {
          path: "rechargeRecord",
          component: RechargeRecord,
          meta: {
            title: "充值记录",
            requireAuth: true
          }
        }
      ]
    },
    {
      path: "/shortLink",
      component: Layout,
      children: [
        {
          path: "shortUrl",
          component: ShortUrl,
          meta: {
            title: "短链接",
            requireAuth: true
          }
        },
        {
          path: "shortData",
          component: shortData,
          meta: {
            title: "数据概括",
            requireAuth: true,
            activePath: "/shortLink/shortUrl"
          }
        },
        {
          path: "shortDataArea",
          component: shortDataArea,
          meta: {
            title: "地域分析",
            requireAuth: true,
            activePath: "/shortLink/shortUrl"
          }
        },
        {
          path: "shortUrl/createOredit",
          component: createOreditShortUrl,
          meta: {
            title: "创建/修改短链",
            requireAuth: true,
            activePath: "/shortLink/shortUrl"
          }
        },
        {
          path: "domain",
          component: ShortUrlDoamin,
          meta: {
            title: "专属域名",
            requireAuth: true
          }
        }
      ]
    },
    {
      path: "/user",
      component: Layout,
      children: [
        {
          path: "accountManage",
          component: AccountManage,
          meta: {
            title: "账号信息",
            requireAuth: true
          }
        },
        {
          path: "subAccountManage",
          component: SubAccountManage,
          meta: {
            title: "子账号管理",
            requireAuth: true
          }
        },
        {
          path: "certification",
          component: Certification,
          meta: {
            title: "实名认证",
            requireAuth: true
          }
        },
        {
          path: "certification/personal",
          component: Personal,
          meta: {
            title: "个人认证",
            requireAuth: true
          }
        },
        {
          path: "certification/company",
          component: Company,
          meta: {
            title: "企业认证",
            requireAuth: true
          }
        },
        {
          path: "certification/authenticated",
          component: Authenticated,
          meta: {
            title: "认证信息",
            requireAuth: true
          }
        },
        {
          path: "certification/record",
          component: CertificationRecord,
          meta: {
            title: "变更记录",
            requireAuth: true
          }
        },
        {
          path: "suAccountDetails",
          component: SuAccountDetails,
          meta: {
            title: "子账号管理",
            requireAuth: true
          }
        }
      ]
    },
    {
      path: "/security",
      component: Layout,
      children: [
        {
          path: "securityManage",
          component: SecurityManage,
          meta: {
            title: "账户安全",
            requireAuth: true
          }
        },
        {
          path: "securityJournal",
          component: SecurityJournal,
          meta: {
            title: "调用日志",
            requireAuth: true
          }
        },
        {
          path: "securityWhiteList",
          component: SecurityWhiteList,
          meta: {
            title: "白名单设置",
            requireAuth: true
          }
        },
        {
          path: "balanceWarning",
          component: BalanceWarning,
          meta: {
            title: "号码预警设置",
            requireAuth: true
          }
        }
      ]
    },
    {
      path: "/message",
      component: Layout,
      children: [
        {
          path: "messageIndex",
          component: MessageIndex,
          meta: {
            title: "站内信",
            requireAuth: true
          }
        },
        {
          path: "messageaAutograph",
          component: MessageaAutograph,
          meta: {
            title: "签名管理",
            requireAuth: true
          }
        },
        {
          path: "messageTemplate",
          component: MessageTemplate,
          meta: {
            title: "模板管理",
            requireAuth: true
          }
        },
        {
          path: "messageRecord",
          component: MessageRecord,
          meta: {
            title: "发送记录",
            requireAuth: true
          }
        },
        {
          path: "messageRecord/detail",
          component: MessageRecordDetail,
          meta: {
            title: "发送号码详情",
            requireAuth: true,
            activePath: "/messageRecord"
          }
        },
        {
          path: "messageSendMessage",
          component: MessageSendMessage,
          meta: {
            title: "模板管理",
            requireAuth: true
          }
        }
      ]
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: {
        title: "登录"
      }
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      meta: {
        title: "注册"
      }
    },
    {
      path: "/forget",
      name: "Forget",
      component: Forget,
      meta: {
        title: "找回密码"
      }
    },
    {
      path: "/sso",
      name: "sso",
      component: SSO,
      meta: {
        title: "授权",
        requireAuth: false
      }
    },
    {
      path: "/finance/createOrder",
      component: CreateOrder,
      meta: {
        title: "购买产品",
        requireAuth: true
      }
    },
    {
      path: "/finance/createMessageOrder",
      component: CreateMessageOrder,
      meta: {
        title: "购买短信套餐",
        requireAuth: true
      }
    },
    {
      path: "/finance/payOrder",
      component: PayOrder,
      meta: {
        title: "购买产品",
        requireAuth: true
      }
    },
    {
      path: "/finance/wechatRecharge",
      component: WechatRecharge,
      meta: {
        title: "购买产品",
        requireAuth: true
      }
    },
    {
      path: "/finance/rechargeResult",
      component: RechargeResult,
      meta: {
        title: "支付成功",
        requireAuth: true
      }
    },
    {
      path: "/finance/openMember",
      component: OpenMember,
      meta: {
        title: "开通成功",
        requireAuth: true
      }
    },
    {
      path: "/finance/openVip",
      component: OpenVip,
      meta: {
        title: "开通会员成功",
        requireAuth: true
      }
    },
    {
      path: "/finance/paymentResult",
      component: PaymentResult,
      meta: {
        title: "充值成功",
        requireAuth: true
      }
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js